import classNames from "classnames";
import { useTranslations } from "next-intl";

import Button from "~/components/common/button";
import { KikReviewsBestForV2Item } from "~/shared/power-reviews-response.interface";

import styles from "./reviews-bestfor.module.scss";
import tooltipStyles from "./reviews-tooltip.module.scss";

type Props = {
  bestForValues: KikReviewsBestForV2Item[];
  filterByTag: (tag: string) => void;
  tagFilters?: string[];
};

export default function ReviewsBestFor(props: Props) {
  const t = useTranslations();
  const { bestForValues, filterByTag, tagFilters } = props;

  const ariaLabel = (tag: KikReviewsBestForV2Item) => {
    const baseTranslation = t("reviews.bestForLabel", { number: tag.count, tag: tag.label });
    const filterRemoval = `. ${t("generic.removeFilter")}`;
    return `${baseTranslation}${isSelected(tag.label) ? filterRemoval : ""}`;
  };

  const isSelected = (tagLabel: string) => {
    return tagFilters?.includes(tagLabel);
  };

  return (
    bestForValues.length > 0 && (
      <div className={styles.reviewsBestFor}>
        <h4 className={styles.reviewsBestForText}>Es mejor para</h4>
        <div className={styles.reviewsBestForTags}>
          {bestForValues.map((tag: KikReviewsBestForV2Item, i: number) => (
            <Button
              key={i + tag.label}
              className={classNames(
                styles.reviewsBestForTag,
                tooltipStyles.reviewsTooltipContainer,
                tooltipStyles.reviewsTooltip,
                { [styles.reviewsBestForTagSelected]: isSelected(tag.label) }
              )}
              aria-label={ariaLabel(tag)}
              data-tooltip={t("reviews.bestForTooltip")}
              onClick={() => filterByTag(tag.label)}
            >
              {`${tag.label} (${tag.count})`}
            </Button>
          ))}
        </div>
      </div>
    )
  );
}
